import { useEffect, useRef } from "react";
import * as powerbi from "powerbi-client";

interface Props {
  embedUrl: string;
  reportId: string;
  accessToken: string;
}

const PowerBIReport: React.FC<Props> = ({
  embedUrl,
  reportId,
  accessToken
}) => {
  const reportRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!reportRef.current) return;

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    powerbiService.reset(reportRef.current);

    const embedConfig: powerbi.IEmbedConfiguration = {
      type: "report",
      id: reportId,
      embedUrl: embedUrl,
      accessToken: accessToken,
      tokenType: powerbi.models.TokenType.Embed,
      settings: {
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false }
        }
      }
    };

    powerbiService.reset(reportRef.current);
    powerbiService.embed(reportRef.current, embedConfig);

    return () => {
    };
  }, [embedUrl, reportId, accessToken]);

  return (
    <div
      ref={reportRef}
      style={{ height: "85vh", width: "95%", border: "0", margin: "0", padding: "0", overflow: "hidden" }}
    />
  );
};

export default PowerBIReport;